'use es6';

import { EEA_ISO_CODES } from '../constants/hspb';
import { isOptIn } from '../constants/privacyPolicy';

// args is here for correctly typing usages, however google requires the arguments object be passed -_-.
// eslint-disable-next-line no-unused-vars
function gtag(...args) {
  const dataLayer = window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  dataLayer.push(arguments);
}
export const canSendConsentToGCM = (countryCode, privacySetting) => {
  return !!(countryCode && !EEA_ISO_CODES.includes(countryCode) || privacySetting && isOptIn(privacySetting));
};
export const sendConsentUpdateViaGCMV2 = (consent, countryCode, privacySetting) => {
  if (!canSendConsentToGCM(countryCode, privacySetting)) {
    return;
  }
  const gcmAdsConsent = consent.categories.advertisement ? 'granted' : 'denied';
  const gcmAnalyticsConsent = consent.categories.analytics ? 'granted' : 'denied';
  gtag('consent', 'update', {
    ad_storage: gcmAdsConsent,
    analytics_storage: gcmAnalyticsConsent,
    ad_user_data: gcmAdsConsent,
    ad_personalization: gcmAdsConsent
  });
};